import axios from 'axios';

const serverFile = axios.create({
  baseURL: process.env.REACT_APP_URL_ARQUIVOS,
});

export default serverFile;
